import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowId, WorkflowInstanceId} from "common/flowmaster/types/workflow";

export type WorkflowInstanceUpdateIsPublicAction = {
  type: WorkflowsActionTypes["WORKFLOW_INSTANCE_UPDATE_IS_PUBLIC"]["SUCCESS"];
  payload: {
    workflow_id: WorkflowId;
    workflow_instance_id: WorkflowInstanceId;
    is_public: boolean;
  };
};

export default function updateWorkflowInstanceIsPublic(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_INSTANCE_UPDATE_IS_PUBLIC,
    (
      organisationId: OrganisationId,
      workflowId: WorkflowId,
      workflowInstanceId: WorkflowInstanceId,
      isPublic: boolean,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/workflow/${workflowId}/workflow_instance/${workflowInstanceId}/public`,
          {
            is_public: isPublic,
          },
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
